export const decimalsToCents = (value: number): number => {
  if (!value || typeof value !== 'number') {
    return 0;
  }

  const splitValues = (value + '').split('.');
  const euros: number = +splitValues[0] * 100;
  let cents: string = splitValues.length > 1 ? splitValues[1] : '00';

  while (cents.length < 2) {
    cents += '0';
  }

  cents = cents.slice(0, 2);

  return euros + (+value >= 0 ? +cents : -cents);
};

export const centsToDecimals = (cents: number, decimals = 2): number => {
  if (!cents || typeof cents !== 'number') {
    return 0;
  }
  const centsAsString: string = cents + '';
  const breakPoint = centsAsString.length - decimals;
  return +(
    centsAsString.slice(0, breakPoint) +
    '.' +
    centsAsString.slice(breakPoint)
  );
};
